import {
  ReceivableTaxType,
  RECEIVABLE_TAX_TYPE_LABELS,
  ReceivableTaxDocumentType,
  RECEIVABLE_TAX_DOCUMENT_TYPE_LABELS,
} from "../../../utils/types";

export const ACCEPTED_DOCUMENT_TYPES = ".pdf,.png,.jpg,.jpeg,.doc,.docx";
export const MAX_DOCUMENT_SIZE_MB = 0.5; // 500KB

export const TAX_TYPE_OPTIONS = Object.entries(RECEIVABLE_TAX_TYPE_LABELS).map(([value, label]) => ({
  value: value as ReceivableTaxType,
  label,
}));

export const TAX_DOCUMENT_TYPE_OPTIONS = Object.entries(RECEIVABLE_TAX_DOCUMENT_TYPE_LABELS).map(
  ([value, label]) => ({
    value: value as ReceivableTaxDocumentType,
    label,
  }),
);

export const getTaxTypeLabel = (value: ReceivableTaxType | string) =>
  RECEIVABLE_TAX_TYPE_LABELS[value as ReceivableTaxType] ?? value;

export const getTaxDocumentTypeLabel = (value: ReceivableTaxDocumentType | string) =>
  RECEIVABLE_TAX_DOCUMENT_TYPE_LABELS[value as ReceivableTaxDocumentType] ?? value;

export const generateTempId = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `pending-tax-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

export const generateTempDocumentId = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `pending-tax-doc-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

